import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getArticles = (category) =>
  client.get("/articles", { params: category ? { category } : {} }).then((r) => r.data);
export const getArticle = (slug) => client.get(`/articles/${slug}`).then((r) => r.data);
export const getProducts = () => client.get("/products").then((r) => r.data);
export const getProduct = (slug) => client.get(`/products/${slug}`).then((r) => r.data);
export const postContact = (payload) => client.post("/contact", payload).then((r) => r.data);
export const subscribeNewsletter = (payload) => client.post("/newsletter", payload).then((r) => r.data);
export const getAvailability = (date) =>
  client.get("/booking/availability", { params: { date } }).then((r) => r.data);
export const createBooking = (payload) => client.post("/booking", payload).then((r) => r.data);
export const createCheckout = (payload) => client.post("/payments/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) => client.get(`/payments/status/${sessionId}`).then((r) => r.data);
